import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TreeItemLabelComponent } from "../treeItemLabelComponent";
import { ExtensionsComponent } from "../extensionsComponent";
import * as React from "react";
import frameGraphIcon from "./ic_fluent_flow_24_filled.svg";
export class FrameGraphTreeItemComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const nrgeIcon = this.props.frameGraph.getLinkedNodeRenderGraph() ? (_jsx("div", { className: "icon", onClick: () => {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.props.frameGraph.getLinkedNodeRenderGraph().edit({ nodeRenderGraphEditorConfig: { hostScene: this.props.frameGraph.scene } });
            }, title: "Node Render Graph Editor", children: _jsx(FontAwesomeIcon, { icon: faPen }) })) : null;
        return (_jsxs("div", { className: "frameGraphTools", children: [_jsx(TreeItemLabelComponent, { label: this.props.frameGraph.name, onClick: () => this.props.onClick(), iconBase64: frameGraphIcon, color: "#6e9189" }), _jsx(ExtensionsComponent, { target: this.props.frameGraph, extensibilityGroups: this.props.extensibilityGroups }), nrgeIcon] }));
    }
}
//# sourceMappingURL=frameGraphTreeItemComponent.js.map